import React from 'react'
import Layout from '../../../components/layouts/Layout'
import { useTranslation } from 'react-i18next'
import PrimaryButtonWithIconAdd from '../../../components/ui/PrimaryButtonWithIconAdd';
import { useCoupounsByAdmin } from '../../../hooks/admin/coupoun.admin';
import { useSearchParams } from 'react-router-dom';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import CoupounsListTable from '../../../components/admin/coupouns/CoupounsListTable';
import EmptyData from '../../../components/ui/EmptyData';
import Pagination from '../../../components/ui/Pagination';
import { PermissionGate } from '../../../components/admin/PermissionGate';
import { PermissionsKey } from '../../../data/permissions';

function AdminViewCoupouns() {
    const {t} = useTranslation();
     const [searchParams,setSearchParams] = useSearchParams();
    const pageQuery = Number(searchParams.get('page')) || 1;
    const {data:coupouns , isError,isLoading} = useCoupounsByAdmin({page:pageQuery});

    const handlePagination = (page: number) => {
            const newParams = new URLSearchParams(searchParams);
            newParams.set('page', page.toString());
            setSearchParams(newParams);
        };


  return (
    <Layout title={t("admin_sidebar.coupouns")} headline=''>
        <div className='flex justify-end'>
            <PermissionGate permissions={[PermissionsKey.CreateCoupon]}>
              <PrimaryButtonWithIconAdd
              buttonLabel="add_new_coupoun"
              buttonLinkPath="/admin/add-coupoun"
              />
            </PermissionGate>
        </div>
    <LoadingErrorState
      isError={isError}
      isLoading={isLoading}
      />
      {coupouns && 
      (
        coupouns.data.length===0 
        ?
        <EmptyData/>
        :
      <>
      <CoupounsListTable copouns={coupouns.data}/>
      <Pagination
      handlePagination={handlePagination}
      totalPages={coupouns.totalPages}
      currentPage={pageQuery}
      />
      </>
      )
      }
    </Layout>
  )
}

export default AdminViewCoupouns